var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.isReportingUser)?_c('reporting-home'):_c('default-home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }